document.documentElement.classList.remove('no-js');

const initialiseIcons = () => {
  if (window.lucide) window.lucide.createIcons({ attrs: { 'stroke-width': 1.8 } });
};

const revealObserver = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8%' })
  : null;

document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('is-ready');
  initialiseIcons();
  document.querySelectorAll('.reveal').forEach((element) => {
    if (revealObserver) revealObserver.observe(element);
    else element.classList.add('is-visible');
  });
});

document.addEventListener('shopify:section:load', initialiseIcons);

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const navigation = document.querySelector('[data-nav]');
  const isOpen = navigation.classList.toggle('is-open');
  toggle.setAttribute('aria-expanded', String(isOpen));
});

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!form.matches('[data-product-form]')) return;
  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  button.disabled = true;
  try {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('Cart request failed');
    const cart = await fetch('/cart.js').then((result) => result.json());
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
    const toast = document.querySelector('#CartToast');
    toast.classList.add('show');
    window.setTimeout(() => toast.classList.remove('show'), 2600);
  } catch (error) {
    form.submit();
  } finally {
    button.disabled = false;
  }
});
